import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';

@Injectable({
  providedIn: 'root',
})
export class PageDownloadService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  downloadRange(startPage: number, endPage: number, categoryId: number, documentId: number, language: string) {
    const url = `${this.apiData.apiURL}api/${this.client}/downloadcenter/page/category/${categoryId}/document/${documentId}/${language}`;
    const body = {
      start_page: startPage,
      end_page: endPage,
    };

    return this.http.post(url, body, { responseType: 'blob' });
  }

  downloadBlob(blob: Blob, filename: string) {
    const link = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(objectUrl);
  }
}
